import React, { Fragment } from "react";
import LeftSideSection from "../../components/authentication/leftSideSection";
import RightSideSection from "../../components/authentication/rightSideSection";
import "../../assets/css/scss/section/_authSection.scss";

export default function signup() {
  return (
    <Fragment>
      <section className="authentication-section">
        <div className="d-flex flex-wrap form-div">
          <LeftSideSection />
          <RightSideSection isSignup={1} />
        </div>
      </section>
    </Fragment>
  );
}
